const pages=[
    "About",
    "Events",
    "Gallery",
    // "Sponsor",
     "Contact",
     "Apply" ]

export default pages